import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { GET_DIET } from "../querykeys";
import { request } from "../api";
import { BaseResponse } from "../types/baseRespones";
import { Diet } from "src/types/Diet";
import { showAlert } from "src/components/containers/Alert";
import { useNavigate } from "react-router-dom";
import axios from "axios";

/* 식단 불러오기 */
export const useDietRegister = (date: string) => {
  return useQuery({
    queryKey: [GET_DIET, date],
    queryFn: async () => {
      const result = await request<BaseResponse<any[]>>({
        method: "GET",
        url: `/diet?date=${date}`,
      });
      return result.response || [];
    },
  });
};

/* selected한 데이터 불러오기 */
export const useSelectedDiet = (date?: string, mealType?: string) => {
  return useQuery({
    queryKey: [GET_DIET, date, mealType],
    queryFn: async () => {
      const result = await request<BaseResponse<Diet[]>>({
        method: "GET",
        url: `/diet?date=${date}`,
        params: { mealType },
      });
      return result.response || [];
    },
    enabled: !!mealType,
  });
};

/* 식단 생성 api */
export const useCreateDiet = () => {
  const queryClient = useQueryClient();
  const navi = useNavigate();

  return useMutation({
    mutationFn: (payLoad: any) => {
      return request<BaseResponse>({
        method: "POST",
        url: `/diet`,
        data: payLoad,
      });
    },
    onSuccess: async (res: any) => {
      if (res.response[0].success) {
        navi("/diet", {
          replace: true,
          state: { toast: res.response[0].message },
        });
      } else {
        await showAlert(res.response[0].message);
      }
      queryClient.invalidateQueries({ queryKey: [GET_DIET] });
    },
  });
};

export const useAIcreateDiet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => {
      const formData = new FormData();
      formData.append("file", file);

      return axios.post(
        "https://ai-food-analyze.insystem.kr/api/analyze",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
    onSuccess: async (res: any) => {
      queryClient.invalidateQueries({ queryKey: [GET_DIET] });
    },
    onError: (err: any) => {
      console.error("❌ AI 분석 에러:", err.response || err);
    },
  });
};

export const useUpdateDiet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payLoad: any) => {
      return request<BaseResponse>({
        method: "PUT",
        url: `/diet`,
        data: payLoad,
      });
    },
    onSuccess: (res: BaseResponse) => {
      queryClient.invalidateQueries({ queryKey: [GET_DIET] });
    },
  });
};
